import { TextField } from '@cimpress/react-components'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Preloader from '../../../common/components/Preloader'
import { getCountryName } from '../../../i18n'
import { CalendarType } from '../../models'
import { PlantCalendarsLegend } from '../legend/CalendarLegend'
import CountryCalendarLegendRow from '../legend/CountryCalendarLegendRow'
import { SelectCalendar } from '../SelectCalendar'
import YearlyCalendar from '../YearlyCalendar'
import { useCountryCalendarContext } from './CountryCalendarContext'
import styles from './CountryCalendarView.module.css'

interface Props {
  changeCalendarView(type: CalendarType): void
}

export default function CountryCalendarView(props: Props) {
  const context = useCountryCalendarContext()

  const yearlyCalendar = (
    <YearlyCalendar
      editable={true}
      calendar={context.countryCalendarMapping[context.selectedCountry].id}
      changeCalendarView={props.changeCalendarView}
      calenderView={'working-days'}
    />
  )

  return (
    <>
      <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 calendar-legend container padding-bottom-full">
        <div
          className="card"
          style={{
            height: '100%',
          }}
        >
          <div className="card-block flex-vertical calendar-content">
            <SelectCalendar disabled={false} />
            <PlantCalendarsLegend />
            <SelectCountrySchedule />
          </div>
        </div>
      </div>
      {yearlyCalendar}
    </>
  )
}

function SelectCountrySchedule() {
  const { t } = useTranslation()
  const context = useCountryCalendarContext()
  const [search, setSearch] = React.useState('')

  const searchChange = (event: React.FormEvent<HTMLInputElement>) => {
    setSearch(event.currentTarget.value)
  }

  const alphabetical = Object.keys(context.countryCalendarMapping)
    .filter(c => !context.lastAccessedCalendars.includes(c))
    .map(c => ({
      label: `${getCountryName(c)} (${c})`,
      value: c,
    }))
    .sort((tc1, tc2) => tc1.label.localeCompare(tc2.label))

  const lastAccessed = context.lastAccessedCalendars.map(c => ({
    label: `${getCountryName(c)} (${c})`,
    value: c,
  }))

  const filtered = [...lastAccessed, ...alphabetical].filter(c =>
    c.label.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  )

  return (
    <div className={styles.selectCountrySchedule}>
      <h5>{t('calendars.country.countryCalendars')}</h5>
      {context.loadingCountryCalendars ? (
        <div className="overflow-y-only">
          <Preloader small={true} />
        </div>
      ) : (
        <>
          <TextField
            name="search"
            label={t('common.search')}
            onChange={searchChange}
            value={search}
          />
          <div className="overflow-y-only">
            {filtered.length === 0 ? (
              <p style={{ textAlign: 'center' }}>
                <small>{t('calendars.noMatchingCalendars')}</small>
              </p>
            ) : (
              filtered.map(tc => (
                <CountryCalendarLegendRow key={tc.value} country={tc} />
              ))
            )}
          </div>
        </>
      )}
    </div>
  )
}
